<!-- Header -->
<template>
  <div class="component-header">
    <!-- Banner 开始 -->
    <img src="../assets/images/toupiao/topbg.jpg" class="banner" />
    <!-- Banner 结束 -->

    <!-- 内容 开始 -->
    <div class="content">
      <!-- 顶部 开始 -->
      <div class="top">
        <div class="main-content">
          <!-- Logo -->
          <div class="logo"></div>
        </div>
      </div>
      <!-- <div
        class="hdgg"
        :class="{
          hdggmobile: isphone,
          hdggpc: isphone == false
        }"
        @click="hdggopen()"
      ></div> -->
      <!-- 顶部 结束 -->

      <!-- 中间 开始 -->
      <!-- <div class="mid">
        <div class="main-content">
          <img src="../assets/images/web_title.png" class="web-title" />
        </div>
      </div> -->
      <!-- 中间 结束 -->
    </div>
    <!-- 内容 结束 -->

    <!-- 导航 开始 -->
    <div class="navs">
      <!-- <img
        src="../assets/images/toupiao/ckline.png"
        alt=""
        srcset=""
        class="ckline"
      /> -->
      <div class="main-content">
        <router-link
          class="link"
          :class="{ active: headerNavIndex == index }"
          :to="item.to"
          v-for="(item, index) in navList"
          :key="index"
          >{{ item.name }}</router-link
        >
      </div>
    </div>
    <!-- 导航 结束 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { listTitles } from "@/api/datas";
export default {
  name: "ComponentHeader",
  data() {
    return {
      isphone: false,
      // 导航菜单列表
      // name: 菜单名称
      // to  : 点击菜单后要跳转的路由路径
      navList: []
    };
  },
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex" // 当前激活的导航菜单的下标
    ])
  },
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
    listTitles().then(resx => {
      this.navList = resx;
      this.loading = false;
    });
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    /**
     * ##########################################################################################
     * @description 头像下拉菜单点击事件
     * @param {String} command : dropdown-item 的指令
     * ##########################################################################################
     */

    handleCommand(command) {
      console.log("点击了菜单:", command);

      // 推出登录
      if (command == "logout") {
        // localStorage.removeItem('YLW_USERINFO')
        this.$store.commit("updateUserInfo", null);
        doLogut().then(res => {
          if (res.code == 200) {
            this.$message({
              message: "退出成功",
              type: "success"
            });
            this.$router.push({
              name: "index"
            });
          } else {
            this.$message.error(res.msg);
          }
        });

        history.pushState(null, null, document.URL);
      }
    },
    hdggopen() {
      //
      window.open(
        "http://www.chinamartyrs.gov.cn/x_xwzx/xwfb/202108/t20210827_50139.html"
      );
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style lang="scss" scoped>
/* 活动公告 */
.hdggpc {
  width: 322px;
  height: 274px;
  font-size: 50px;
  top: 590px;
  right: 380px;
  position: absolute;
  color: rgb(206, 36, 36);
  font-family: "Courier New", Courier, monospace;
  background: url("../assets/images/toupiao/hdgg.png") no-repeat center top;
  background-size: 100%;
  text-align: center;
  align-items: center;
  font-family: YouShe2;
  // background-color: rgb(49, 68, 173);
  -webkit-animation: tada 1.7s linear infinite;
  -moz-animation: tada 1.7s linear infinite;
  &:hover {
    cursor: pointer;
    color: rgb(226, 110, 110);
  }
  &:active {
    cursor: pointer;
    color: rgb(131, 25, 25);
  }
}
.hdggmobile {
  width: 182px;
  height: 170px;
  top: 380px;
  right: 260px;
  color: rgb(206, 36, 36);
  position: absolute;

  font-family: "Courier New", Courier, monospace;
  background: url("../assets/images/toupiao/hdgg.png") no-repeat center top;
  background-size: 100%;
  text-align: center;
  align-items: center;
  font-family: YouShe2;
  // background-color: rgb(49, 68, 173);
  -webkit-animation: tada 1.7s linear infinite;
  -moz-animation: tada 1.7s linear infinite;
  &:hover {
    cursor: pointer;
    color: rgb(226, 110, 110);
  }
  &:active {
    cursor: pointer;
    color: rgb(131, 25, 25);
  }
}
.hdggpc {
}
/* 参考线 */
.ckline {
  height: 12px;
  width: 100%;
  position: absolute;
  top: -9px;
  display: block;
}

.component-header {
  position: relative;
  min-width: 1200px;
}

.banner {
  display: block;
  width: 100%;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding-bottom: 58px;
}

.top {
  flex-shrink: 0;
  height: 80px;
  border-bottom: 1px solid rgba(255, 238, 205, 0.2);
}

.top .main-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top .logo {
  width: 132px;
  height: 99px;
  position: relative;
  top: 60px;
  left: 90px;
  color: #ce2424;
  background: url(../assets/images/toupiao/logo.png) no-repeat center top;
  background-size: 100%;
}

.top .links {
  display: flex;
  align-items: center;
}

.top .link {
  font-size: 26px;
  color: #ffffff;
  width: 75px;
  height: 38px;
  line-height: 38px;
  text-align: center;
}

.top .link-register {
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  border-radius: 10px;
  color: var(--main-color);
  font-weight: bold;
}

.mid {
  flex: 1;
}

.mid .main-content {
  height: 100%;
  display: flex;
  align-items: center;
}

.mid .web-title {
  height: 73px;
}

.navs {
  width: 100%;
  height: 122px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: var(--main-color);
  z-index: 20;
}

.navs .main-content {
  height: 100%;
  display: flex;
}

.navs .link {
  flex: 1;
  flex-shrink: 0;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.4s;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 36px;
  font-family: "思源宋体";
  position: relative;
}

.navs .link:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.navs .link::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  background: #fff;
  left: 0;
  top: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.4s;
}

.navs .link:hover {
  color: var(--main-color);
  font-weight: bold;
  font-size: 36px;
}

.navs .link:hover::after {
  opacity: 1;
  transform: scale(1);
}

.navs .link.active {
  color: var(--main-color);
  font-weight: bold;
  font-size: 36px;
}

.navs .link.active::after {
  opacity: 1;
  transform: scale(1);
}

.has-login-wrapper {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.has-login-wrapper .link-mine {
  color: #f7f17d;
  font-weight: bold;
  margin-right: 16px;
}

.has-login-wrapper .userinfo {
  display: flex;
  align-items: center;
}

.has-login-wrapper .avatar {
  width: 48px;
  height: 48px;
  border: 2px solid #fbd48b;
  margin-right: 8px;
  cursor: pointer;
}

.has-login-wrapper .nickname {
  color: #ffffff;
}
.has-login-wrapper .logouts {
  color: #bb1515;
  border: solid 1px #ef7878;
  padding: 3px;
  background-color: #eae3b6;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}
.has-login-wrapper .logouts:hover {
  color: #e72c2c;
}
.has-login-wrapper .logouts:active {
  color: #9b2020;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue